import React from 'react';
import { MonthYear } from './types';
import { DateTime } from 'luxon';
import { View } from 'react-native';
import PressableDynamicOpacity from '../PressableDynamicOpacity';
import Text from '../Text';

export type YearScanMonthSelectorOwnProps = {
    yearScanValue: number;
    onMonthYearChange: (monthYear: MonthYear) => void;
    height: number;
    renderYearScanMonth?: (monthYear: MonthYear) => React.ReactNode;
};

export type YearScanMonthSelectorProps = YearScanMonthSelectorOwnProps;

const months = new Array(12).fill(0).map((_, index) => index + 1);
const monthRows = new Array(4).fill(0).map((_, index) => months.slice(index * 3, index * 3 + 3));

const YearScanMonthSelector: React.FC<YearScanMonthSelectorProps> = (props) => {
    return (
        <View style={{ height: props.height, alignSelf: 'stretch' }}>
            {monthRows.map((row, rowIndex) => (
                <View key={rowIndex} style={{ flexDirection: 'row', flex: 1 }}>
                    {row.map((month) => (
                        <PressableDynamicOpacity
                            key={month}
                            style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}
                            onPress={() => props.onMonthYearChange({ month, year: props.yearScanValue })}
                            testID={`calendar-scan-month-${month}`}
                        >
                            {props.renderYearScanMonth ? (
                                props.renderYearScanMonth({ month, year: props.yearScanValue })
                            ) : (
                                <Text variant="body-1">
                                    {DateTime.fromObject({ year: props.yearScanValue, month }).toFormat('LLLL')}
                                </Text>
                            )}
                        </PressableDynamicOpacity>
                    ))}
                </View>
            ))}
        </View>
    );
};

export default React.memo(YearScanMonthSelector);
